import script from "./Filter.vue?vue&type=script&setup=true&lang=js"
export * from "./Filter.vue?vue&type=script&setup=true&lang=js"

import "./Filter.vue?vue&type=style&index=0&id=fd07c6d6&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd07c6d6"]])

export default __exports__